export default __webpack_public_path__ + "static/media/project5.eaea297c.png";